<template>
  <v-btn :id="id" fab small :color="color" v-bind="$attrs" v-on="$listeners">
    <v-icon :color="iconColor" v-text="icon" />
    <template #loader>
      <slot name="loader">
        <v-progress-circular size="24" width="3" indeterminate />
      </slot>
    </template>

    <v-tooltip v-bind="computedTooltipProps" :disabled="!tooltip && !$slots.tooltip" :activator="`#${id}`" eager>
      <slot name="tooltip"><span v-text="tooltip" /></slot>
    </v-tooltip>
  </v-btn>
</template>

<script>
const tooltipAlignChoices = ['top', 'bottom', 'left', 'right']

export default {
  name: 'ActionBtn',
  props: {
    icon: { type: String, required: true },
    color: { type: String, default: () => 'primary' },
    iconColor: { type: String, default: () => undefined },
    tooltip: { type: String, default: () => '' },
    tooltipProps: { type: Object, default: () => {} },
    tooltipAlign: { type: String, default: () => 'bottom', validator: (v) => tooltipAlignChoices.includes(v) },
  },
  computed: {
    id() {
      return `action-btn-${this._uid}`
    },
    computedTooltipProps() {
      return Object.assign({}, this.tooltipProps, { [this.tooltipAlign]: true })
    },
  },
}
</script>
